const GOVERNANCE_REQUEST_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isGovernanceRequestId = (value?: string | null) => GOVERNANCE_REQUEST_ID.test((value || '').trim());
